import { render, staticRenderFns } from "./RenewalTerms.vue?vue&type=template&id=6164c686"
import script from "./RenewalTerms.vue?vue&type=script&lang=js"
export * from "./RenewalTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RenewalTerms.vue"
export default component.exports